<template>
	<PopupRouterView label="Purchase Order Status Input"  entityName="OutgoingDocumentApprovalStatus" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" />
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import OutgoingDocumentApprovalStatus from '@/models/OutgoingDocumentApprovalStatus/OutgoingDocumentApprovalStatus';
import OutgoingDocumentApprovalStatusList from '@/models/OutgoingDocumentApprovalStatus/OutgoingDocumentApprovalStatusList';
import OutgoingDocumentApprovalStatusFilter from '@/filters/OutgoingDocumentApprovalStatus/OutgoingDocumentApprovalStatusFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,PopupRouterView},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterOutgoingDocumentApprovalStatus : null,
			currentOutgoingDocumentApprovalStatusPage : 1,
			outgoingOutgoingDocumentApprovalStatusPageSize: 10,
			sortByOutgoingDocumentApprovalStatus: '',
			sortDescOutgoingDocumentApprovalStatus: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getOutgoingDocumentApprovalStatus : async function(id) {
			this.isBusy = true;
			OutgoingDocumentApprovalStatus.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadOutgoingDocumentApprovalStatus = true;
			this.filterOutgoingDocumentApprovalStatus.id = this.modelId;
			OutgoingDocumentApprovalStatus.downloadDataDetail(this, this.filterOutgoingDocumentApprovalStatus).then(result => {
				this.isDownloadOutgoingDocumentApprovalStatus = false;
			}).catch(error => { this.isDownloadOutgoingDocumentApprovalStatus = false; })
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					OutgoingDocumentApprovalStatus.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'outgoingdocumentapprovalstatusindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				} else {
					OutgoingDocumentApprovalStatus.insertData(this, model).then(result => {
						this.$router.push({ name: 'outgoingdocumentapprovalstatusindex' });
						this.isBusy = false;
						this.$store.dispatch('addSuccessMessageGlobal', "Data Berhasil disimpan");
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			/*Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					OutgoingDocumentApprovalStatus.updateData(this, model, id);
				}
			});*/
		},
		onHidden() {
			this.getOutgoingDocumentApprovalStatuss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterOutgoingDocumentApprovalStatus = new OutgoingDocumentApprovalStatusFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getOutgoingDocumentApprovalStatus(id);
			} else {
				this.modelId = id;
				this.getOutgoingDocumentApprovalStatus(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			//OutgoingDocumentApprovalStatus.discardData(this, this.modelId);
		}
	},
}
</script>
